import { styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_FIELDS_FLOATING,
  ERROR_CIRCULAR_PROGRESS_BAR,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  PASS_CIRCULAR_PROGRESS_BAR,
  PLAIN_TEXT,
  WARNING_CIRCULAR_PROGRESS_BAR,
  WARNNG_TEXT_BACKGROUND,
} = COLORS;

export const EditProfileSideInfoLargeViewAvatarContainer = styled('div')(({ theme }) => ({
  backgroundColor: 'transparent',
  borderRadius: '8px',
  aspectRatio: '95/132',
  width: '100%',
  height: 'auto',
  flexShrink: 0,
  position: 'relative',
  '&:hover': {
    '& .cameraIconButton': {
      opacity: '1 !important',
    },
  },
}));

export const EditProfileSideInfoLargeViewAvatar = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 4,
}));

export const EditProfileSideInfoLargeViewDetailsContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderRadius: 8,
  padding: 20,
  display: 'grid',
  gap: 10,
}));

export const EditProfileProgressText = styled('p')(({ theme, progress }: { theme: Theme; progress: number }) => ({
  textTransform: 'uppercase',
  fontSize: '14px',
  fontWeight: 500,
  color:
    progress < 50
      ? ERROR_CIRCULAR_PROGRESS_BAR
      : progress === 100
        ? PASS_CIRCULAR_PROGRESS_BAR
        : WARNING_CIRCULAR_PROGRESS_BAR,
  marginBottom: 10,
}));

export const EditProfilePrivateText = styled('p')(({ theme }) => ({
  textTransform: 'uppercase',
  fontSize: '14px',
  fontWeight: 500,
  color: PLAIN_TEXT,
  backgroundColor: WARNNG_TEXT_BACKGROUND,
  padding: '1px 5px',
  maxWidth: 'fit-content',
  borderRadius: 4,
}));
